import React from "react";

export const stateLabel = (status) => {
  const s = String(status ?? "").toLowerCase().trim();
  if (s === "stop") return "정지 회원";
  if (s === "deleted") return "탈퇴 회원";
  return "일반 회원";
};

export const subscriptionLabel = (type) => {
  const v = String(type ?? "").toLowerCase().trim();
  if (!v) return "해지";
  if (v === "standard" || v === "premium") return "구독중";
  if (v === "basic") return "단건결제";
  return "-";
};

export default function UserStateModal({ detail }) {
  const path = [
    detail?.large_category_name,
    detail?.medium_category_name,
    detail?.small_category_name,
  ].filter(Boolean).join(" > ") || "-";

  const Row = ({ label, value, span = 2 }) => (
    <div className={`col-span-${span}`}>
      <div className="text-neutral-400">{label}</div>
      <div
        className="text-neutral-900 font-medium truncate"
        title={typeof value === "string" ? value : undefined}
      >
        {value ?? "-"}
      </div>
    </div>
  );

  return (
    <div className="grid grid-cols-6 gap-x-6 gap-y-4 py-2 text-sm">
      <Row label="회원상태" value={stateLabel(detail?.status)} />
      <Row label="구독 상태" value={subscriptionLabel(detail?.subscription_type)} span={4} />
      <Row label="이름" value={detail?.name} />
      <Row label="생년월일" value={detail?.birth_year} />
      <Row label="휴대폰번호" value={detail?.phone} />
      <Row label="업종" value={path} span={6} />
    </div>
  );
}
